import BaseFactory from 'services/sports/default/base-factory';
import UserAdjustmentsValidatorBuilder from './user-adjustments-validator-builder';

class Factory extends BaseFactory {
    createObj(objectName, params) {
        return new UserAdjustmentsValidatorBuilder(params);
    }
}

export {Factory};
